import React from 'react';
import ReactDOM from 'react-dom';
import { AppInstaller } from '@wix/app-installer-client-core';
import type {
  InstallAppResponse,
  InstallationFailedResponse,
} from '@wix/app-installer';
import type { InstallAppApiProps } from '@wix/app-installer/internal-use';

export const renderAppInstaller = ({
  panoramaClient,
  ...props
}: InstallAppApiProps): Promise<InstallAppResponse> => {
  const modalContainer = document.createElement('div');
  modalContainer.id = 'app-installer';

  return new Promise((resolve, reject) => {
    const closeModal = () => {
      if (modalContainer) {
        ReactDOM.unmountComponentAtNode(modalContainer);
        modalContainer.remove();
      }
    };

    const onInstallationFailed = (error: InstallationFailedResponse) => {
      reject(error);
      closeModal();
    };

    const onInstallationCompleted = (installResponse: InstallAppResponse) => {
      resolve(installResponse);
      closeModal();
    };
    document.body.appendChild(modalContainer);
    ReactDOM.render(
      <AppInstaller
        {...props}
        panoramaClient={panoramaClient?.createClientForComponent()}
        onInstallationCompleted={onInstallationCompleted}
        onInstallationFailed={onInstallationFailed}
      />,
      modalContainer,
      () => {
        panoramaClient?.reportLoadFinish({
          appId: props.appId,
          tenantId: props.tenantId,
          url: window.location.href,
        });
      },
    );
  });
};
